/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timer-btn[_ngcontent-%COMP%]{position:relative;left:16px;min-width:160px}.timer-duration[_ngcontent-%COMP%]{position:relative;left:30px}\n/*# sourceMappingURL=timer.component.css.map*/"];
export { styles as styles };
